export * from './fontawesome.icons';
export * from './material-design.icons';
